// @ts-nocheck
/* eslint-disable */
export const asEnergyPerformanceCertificateIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 11.4142C3 11.149 3.10536 10.8946 3.29289 10.7071L11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L20.7071 10.7071C20.8946 10.8946 21 11.149 21 11.4142V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V11.4142Z" fill="currentColor"/></svg>`,
    name: 'energy-performance-certificate' as const
};